"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShiftingSubheaderContent = void 0;
/*
 * This is a helper for when we have two components in the Subheader,
 *  for example, a Quicklinks Bar that gets "flipped" with an Article
 *  Progress Bar on scroll. This is used in conjunction with the
 *  shiftUp attribute in <SubHeader />.
 */
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const _utils_1 = require("@utils"); // Component
var ShiftingSubheader = function ShiftingSubheader(_ref) {
    var children = _ref.children, shiftWaypointSelector = _ref.shiftWaypointSelector, shiftOffset = _ref.shiftOffset, unshiftWaypointSelector = _ref.unshiftWaypointSelector, unshiftOffset = _ref.unshiftOffset;
    var shiftWaypoint = _utils_1.useWaypoint({
        waypointSelector: shiftWaypointSelector,
        offset: shiftOffset
    });
    var unshiftWaypoint = unshiftWaypointSelector !== undefined ? _utils_1.useWaypoint({
        waypointSelector: unshiftWaypointSelector,
        offset: unshiftOffset
    }) : undefined;
    var shiftUp = unshiftWaypoint === undefined ? shiftWaypoint : shiftWaypoint && !unshiftWaypoint;
    return /*#__PURE__*/ react_1.default.createElement(Wrapper, null, /*#__PURE__*/ react_1.default.createElement(exports.ShiftingSubheaderContent, {
        shiftUp: shiftUp
    }, children));
}; // Styling
var Wrapper = styled_components_1.default.div.withConfig({
    displayName: "ShiftingSubheader__Wrapper",
    componentId: "to3w31-0"
})(["position:relative;height:100%;width:100%;overflow:hidden;"]);
exports.ShiftingSubheaderContent = styled_components_1.default.div.withConfig({
    displayName: "ShiftingSubheader__ShiftingSubheaderContent",
    componentId: "to3w31-1"
})(["position:absolute;width:100%;height:100%;transition:transform 0.5s ease-in-out 0.35s;will-change:transform;transform:translate3d( 0,", "%,0 );"], function (props) {
    return !props.shiftUp ? 0 : -100;
});
exports.default = ShiftingSubheader;
